export default String.raw`
.wishlist-popup {
    .dialog {
        &__header-title {
            @include h3-headline;
        }

        &__content {
            padding: 24px 16px 16px 16px;
        }
    }
}
`